function avatarTextSize(variant, magnitude) {
  const scale = variant === "organisation" ? {
    xsmall: "sm",
    small: "md",
    medium: "xl",
    large: "xxl",
    xlarge: "xxxl"
  } : {
    xsmall: "xs",
    small: "sm",
    medium: "md",
    large: "xl",
    xlarge: "xxl"
  };
  return scale[magnitude];
}
export {
  avatarTextSize
};
